import React from "react";
import { useAuth } from "../../context/AuthContext";

/**
 * Gate that hides or denies a page to non-admin client users.
 * Backend enforcement is the source of truth — this is purely cosmetic.
 *
 * <RequireClientAdmin fallback={null}>...</RequireClientAdmin>  → silently hide
 * <RequireClientAdmin>...</RequireClientAdmin>                  → show "not allowed" placeholder
 */
export default function RequireClientAdmin({ children, fallback }) {
  const { user } = useAuth();
  if (user?.clientRole === "admin") return children;
  if (fallback !== undefined) return fallback;
  return (
    <div className="empty-state" style={{ marginTop: "3rem" }}>
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" width="48" height="48">
        <rect x="3" y="11" width="18" height="11" rx="2" /><path d="M7 11V7a5 5 0 0110 0v4" />
      </svg>
      <h3>Admin-only area</h3>
      <p>This page is available to venue admins only. Ask your admin if you need access.</p>
    </div>
  );
}
